module.exports = __webpack_public_path__ + "static/media/imagegroup.d3b2fd22.svg";